export var getUrl = function (basePath, tabName) {
    return tabName ? "".concat(basePath, "/").concat(tabName) : "".concat(basePath, "/:activeTab");
};
